module.exports = "/images/signature-verified.png?ba7fa932b88b7216eadedb473af12354";